import { render } from "./TransferToQueue.vue?vue&type=template&id=381d3068&ts=true"
import script from "./TransferToQueue.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransferToQueue.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/connect-flow/components/flow/nodes/TransferToQueue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "381d3068"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('381d3068', __exports__)) {
    api.reload('381d3068', __exports__)
  }
  
  module.hot.accept("./TransferToQueue.vue?vue&type=template&id=381d3068&ts=true", () => {
    api.rerender('381d3068', render)
  })

}


export default __exports__